<template>
   <v-layout row wrap>
      <v-flex xs12>
         <v-card>
            <v-card-text>
               <div v-if="!isComplete">{{ answerCount }} / {{ questionCount }}</div>
               <div v-if="mode === 'caregiver' && isComplete" class="score" v-html="scoreDescription"></div>
               <div class="intro" v-html="survey.params.intro"></div>
               <div v-for="(question, index) in questions" class="question" :key="index">
                  <div class="index">Question {{ index+1 }}</div>
                  <div v-html="question.text"></div>
                  <div class="choices">
                     <v-radio-group :value="userSurvey.answers[index]">
                        <v-radio
                           v-for="(choice, choiceIndex) in question.choices"
                           :key="choiceIndex"
                           :label="choice.text"
                           :value="choiceIndex"
                           @change="saveAnswer(index, $event)"
                        ></v-radio>
                     </v-radio-group>
                  </div>
                  <v-divider v-if="index + 1 < questions.length" :key="1000" class="separ"></v-divider>
               </div>
            </v-card-text>
         </v-card>
      </v-flex>
   </v-layout>
</template>

<script>
   import Vue from 'vue'
   import _ from 'lodash'
   
   export default {

      props: {
         userSurveyId: Number,
         baseRoute: String,
         mode: String, // 'patient', 'caregiver'
      },

      data () {
         return {
            editedAnswers: [],
         }
      },

      computed: {
         // warning: 'answers' attribute is not reactively updated
         userSurvey () {
            return this.$store.state.surveys.userSurveys[this.userSurveyId]
         },
         // reactively updated
         userSurveyAnswers () {
            return this.$store.state.surveys.userSurveys[this.userSurveyId]['answers']
         },
         userSurveyAnswerStrings () {
            return this.$store.state.surveys.userSurveyAnswers[this.userSurveyId]
         },
         survey () {
            return this.$store.state.surveys.surveys[this.userSurvey.survey]
         },
         questions () {
            return this.survey.params.questions
         },
         scoreDescription () {
            let self = this
            return this.survey.params.dimensions.map(function(dimension) {
               let score = self.survey.params.questions.reduce(function(cumul, question, index) {
                  let answer = self.userSurveyAnswers[index]
                  if (dimension.computation === 'sum' || dimension.computation === 'sum_with_offset') {
                     return cumul + question.choices[answer].value[dimension.uid]
                  }
               }, 0)
               if (dimension.computation === 'sum_with_offset') {
                  score += dimension.offset
               }
               score = Math.round(score*100)/100;
               return `<div>${dimension.name} : ${score}</div>`
            }).join('')
         },
         questionCount () {
            return this.survey.params.questions.length
         },
         answerCount () {
            return this.userSurveyAnswers.reduce(function(accu, answer) {
               if (answer === null) {
                  return accu
               } else {
                  return accu + 1
               }
            }, 0)
         },
         isComplete () {
            return this.questionCount ===  this.answerCount
         },
      },

      methods: {
         saveAnswer(questionIndex, answer) {
            console.log('questionIndex', questionIndex, 'answer', answer)
            let userSurveyCopy = _.cloneDeep(this.userSurvey)
            let answers = this.userSurveyAnswers
            answers[questionIndex] = answer
            userSurveyCopy.answers = answers
            //this.$store.commit('surveys/SET_USER_SURVEY', userSurveyCopy)
            //return

            try {
               this.$store.dispatch('surveys/PUT_USER_SURVEY', userSurveyCopy)
            } catch(e) {
               this.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de l'enregistrement", color: 'red' })
            }
         }
      },
   }
</script>


<style scoped lang="scss" type="text/scss">

.score {
   color: white;
   padding: 20px;
   margin-bottom: 20px;
   background-color: orange;
   font-size: 1.2em;
}

.intro {
   font-size: 1.2em;
   font-weight: bold;
   padding-bottom: 15px;
}

.question {
   font-size: 1.1em;

   .index {
      font-size: 1.05em;
      padding-top: 5px;
      padding-bottom: 5px;
      color: #888888;
   }

   .text {
      color: #333333;
   }

   .choices {
      color: red;
      padding-left: 15px;
   }

   .separ {
      margin-top: 5px;
      margin-bottom: 5px;
   }
}

</style>



// WEBPACK FOOTER //
// SurveyAnswers.vue?05937c6f